import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasFraction',
  standalone: true,
})
export class HasFractionPipe implements PipeTransform {
  public transform(form: Partial<{ quantity: string | number; validToDate: string | Date }>): boolean {
    return form.quantity && Number(form.quantity) % 1 !== 0;
  }
}
